<template>
  <WizardContainer
    width="800px"
    height="500px"
  >
    <WizardContent
      :graphic="{
        type: 'gradient',
        assetsPath: 'image-verify-email',
      }"
    >
      <h1 class="page-title mt-6 mb-9">
        Please Check Your Email
      </h1>
      <p class="p3 mb-6">
        We've sent you an email at {{ email }} with a password reset link.
      </p>
      <h2 class="text-h1 mb-4">
        Didn't receive the email?
      </h2>
      <WizardFooter>
        <p class="text-h2">
          Try checking your spam folder or resend it by
          <a @click="resendPasswordResetEmail">clicking here</a>.
        </p>
      </WizardFooter>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';
import WizardFooter from '@/components/shared/WizardFooter.vue';
import { signupSendPasswordResetEmail } from '@/api/signup';
import { mapActions } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'PasswordResetSuccess',
  components: {
    WizardContainer,
    WizardContent,
    WizardFooter,
  },
  emits: ['track-page-load'],
  data() {
    return {
      email: this.$route.query.email || '',
    };
  },
  created() {
    if (!this.email) {
      this.$router.push({
        name: 'password-reset',
      });
    }
  },
  mounted() {
    this.updateFlash({ status: 'success', message: 'Email sent! Please check and confirm.' });
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Password Reset Success' });
  },
  methods: {
    ...mapActions(useWizard, ['updateFlash', 'resetFlash']),
    async resendPasswordResetEmail() {
      try {
        this.resetFlash();
        await signupSendPasswordResetEmail({ email: this.email });
        this.updateFlash({ status: 'success', message: 'Password reset email resent!' });
      } catch (e) {
        this.updateFlash({ message: 'Something went wrong' });
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 36px;
}
</style>
